
import { AccountManager } from "@/components/management/AccountManager";
import { AccountSummaryCard } from "@/components/cards/AccountSummaryCard";
import { MobileLayout } from "@/components/layout/MobileLayout";
import { useIsMobile } from "@/hooks/use-mobile";
import { Card, CardContent } from "@/components/ui/card";
import { useContas } from "@/hooks/useContas";

export default function Accounts() {
  const isMobile = useIsMobile();
  const { 
    contas, 
    loading, 
    saldoTotal, 
    fetchContas, 
    createConta, 
    updateConta, 
    deleteConta 
  } = useContas();

  const handleTabChange = (tab: string) => {
    // Handle tab navigation if needed
  };

  const handleTransactionSuccess = () => {
    fetchContas();
  };

  if (isMobile) {
    return (
      <MobileLayout
        currentTab="accounts"
        onTabChange={handleTabChange}
        onTransactionSuccess={handleTransactionSuccess}
      >
        <div className="max-w-7xl mx-auto px-4 space-y-6">
          <AccountSummaryCard saldoTotal={saldoTotal} loading={loading} />
          <AccountManager 
            contas={contas}
            loading={loading}
            onCreate={createConta}
            onUpdate={updateConta}
            onDelete={deleteConta}
            onRefresh={fetchContas}
          />
        </div>
      </MobileLayout>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="p-3 sm:p-4 md:p-6">
        <div className="max-w-7xl mx-auto">
          <Card>
            <CardContent className="p-6 space-y-6">
              <AccountSummaryCard saldoTotal={saldoTotal} loading={loading} />
              <AccountManager 
                contas={contas}
                loading={loading}
                onCreate={createConta}
                onUpdate={updateConta}
                onDelete={deleteConta}
                onRefresh={fetchContas}
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
